export default __webpack_public_path__ + "static/regulamin-ece54f0de74cb205540c5ea6a5100839.pdf";